<script>
import {defineComponent} from 'vue'
import {ElMessage, ElNotification} from "element-plus";
import http from "@/http";

export default defineComponent({
  name: "SchoolCategoryForm",
  data() {
    return {
      loading: false,
      form: {
        id: null,
        title: {
          uz_cyr: null,
          uz_lat: null,
          kr: null,
          en: null,
          ru: null
        },
        icon: null,
        order: 0
      },
      baseUrl: process.env.VUE_APP_BASE_API_URL + 'api/v2/info/file/',
      rules: {
        title: {
          uz_lat: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          uz_cyr: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          ru: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          en: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          kr: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        }
      }
    }
  },
  methods: {
    uploadImg(event) {
      this.loading = true;
      const files = event.target.files
      const imagesList = new FormData()
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      for (const img of files) {
        this.loading = true
        imagesList.append('file', img)
        http
            .post(url, imagesList, {
              headers: {
                Authorization: this.$store.state.accessToken,
                "Content-Type": "multipart/form-data",
              },
            }).then(({data}) => {
          this.form.icon = data.hashId;
        })
            .catch((err) => {
              ElMessage.error(
                  err.response.data.message || `Hatolik qayta urinib ko'ring`
              );
            })
            .finally(() => {
              this.loading = false
            })
      }
    },
    handleImageUpload() {
      const fileInputId = document.getElementById('fileInputRef');
      fileInputId.click()
    },
    onClickRemove() {
      this.form.icon = null
    },
    getCategoryById() {
      this.loading = true;
      this.$http
          .get(`/api/v1/my-school/initiative-categories/${this.form.id}`)
          .then(({data}) => {
            this.form = data;
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;

          let http;
          if (this.form.id) {
            http = this.$http.put(`/api/v1/my-school/initiative-categories/${this.form.id}`, this.form);
          } else {
            http = this.$http.post("/api/v1/my-school/initiative-categories", this.form);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getCategoryById();
    }
  }
})
</script>

<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="O'zbekcha nomi" prop="title.uz_lat">
                <el-input type="text" v-model="form.title.uz_lat"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="O'zbek-kirilcha nomi" prop="title.uz_cyr">
                <el-input type="text" v-model="form.title.uz_cyr"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Ruscha nomi" prop="title.ru">
                <el-input type="text" v-model="form.title.ru"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Inglizcha nomi" prop="title.en">
                <el-input type="text" v-model="form.title.en"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Qoraqalpoqcha nomi" prop="title.kr">
                <el-input type="text" v-model="form.title.kr"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tartibi" prop="order">
                <el-input-number style="width: 100%" type="number" v-model="form.order"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-button id="upload_img" class="info-btn form-input" @click="handleImageUpload">
                <input type="file" id="fileInputRef" @change="uploadImg" style="display: none"/>
                <img src="@/assets/images/gallery.svg" alt="gallery" style="margin-right: 4px"/>
                Kategoriya fotosuratini yuklang
              </el-button>
            </el-col>
            <div class="images">
              <div class="image-item">
                <el-image
                    style="margin:15px 0;height: 120px;width: 120px; border:1px solid #e4e4e4; border-radius: 4px;"
                    :src="baseUrl+form.icon"
                    fit="contain"/>
              </div>
            </div>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                >Orqaga
                </el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                >Saqlash
                </el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.images {
  columns: 3;

  .image-item {
    position: relative;

    :deep(el-image) {
      border: 1px solid #e4e4e4;
    }
  }
}
</style>
